import * as React from 'react';
import jsbarcode from 'jsbarcode';

interface Props {
  value: string;
}

const Barcode: React.FunctionComponent<Props> = ({ value }) => {
  React.useEffect(() => {
    jsbarcode('.receipt-barcode').EAN13(value, { height: 40, fontSize: 14 }).render();
  }, [value]);
  return <svg className="receipt-barcode" />;
};

export default Barcode;
